<template>
  <div class="plans">
    <h1>教学计划</h1>
    <a-spin :spinning="teachPlanSpinning">
      <div class="content">
        <table class="table">
          <tr>
            <th>计划学期</th>
            <th>安排学期</th>
            <th>课程类型</th>
            <th>课程名称</th>
            <th>学分</th>
            <th>学时</th>
            <th>网络学习</th>
            <th>网络考试</th>
            <th>考核方式</th>
          </tr>
          <tr v-for="(item, index) in arr" :key="index">
            <td>{{ item.planYear + item.planTermName }}</td>
            <td>{{ item.layoutYear + item.layoutTermName }}</td>
            <td>{{ item.courseType }}</td>
            <td>{{ item.viewName }}</td>
            <td>{{ item.lessonPeriod }}</td>
            <td>{{ item.lessonHour }}</td>
            <td>{{ item.dict.webLearnFlag }}</td>
            <td>{{ item.dict.isWebTestFlag }}</td>
            <td>{{ item.dict.checkMethod }}</td>
          </tr>
        </table>
<!--        <div style="text-align:center;font-weight: 700;">*说明：本科标“*”的为学位课程，专科标“*”的为专业课程 </div>-->
        <div class="text-center margin-bottom-20">
          <!-- <div class="page">
          <button class="btn btn-default margin-right-10" :class="{'active':activenum === 0}" type="submit" @click="primaryPage" >首页</button>
          <button class="btn btn-default margin-right-10" type="submit" @click="prePage" :class="{'active':activenum === 1}">上页</button>
          <button class="btn btn-default margin-right-10" type="submit" @click="nextPage" :class="{'active':activenum === 2}">下页</button>
          <button class="btn btn-default margin-right-10" type="submit" @click="lastPage" :class="{'active':activenum === 3}">尾页</button>
          <button class="btn btn-default" type="submit" style="background: none">{{current_page}}/{{Math.ceil(arrs.length/pagesize)}}</button>
        </div> -->
        </div>
        <div class="result text-right" >
          <span
            >教学计划：<strong>{{ arr.length }}科</strong></span
          >
        </div>
      </div>
    </a-spin>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "PlanList",
  data: function () {
    return {
      arr: [],
      teachPlanSpinning: true,
    };
  },
  computed: {
    ...mapState(["userInfo"]),
  },
  methods: {
    getPlanList() {
      this.axios.get(`/biz/subject/plan/list`).then((res) => {
        if (res.success) {
          this.teachPlanSpinning = false;
          this.arr = res.result;
        }
      });
    },
  },
  created() {
    this.getPlanList();
  },
};
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl';
@import '~styles/mixins.styl';

.plans {
  min-height: calc(100vh - 584px);

  h1 {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 20px;
  }

  .content {
    background: #fff;
    padding: 28px;

    .result {
      background: #f8faf9;
      padding: 20px;
      margin-bottom: 30px;
      margin-top: 10px;
      color: #999999;
      width: 100%;

      strong {
        font-weight: bold;
        margin-right: 20px;
        color: #333;
      }
    }
  }

  .btn {
    width: 80px;
    height: 32px;
    line-height: 32px;
    padding: 0;
    background: #cbccce;
    text-align: center;
    color: #fff;
    border: none;
  }

  .active {
    background: $bgColor;
  }

  th {
    text-align: center;
    background: #f6f6f8;
    padding: 12px 0;
    border: 1px solid #fff;
  }

  td {
    text-align: center;
    padding: 12px 0;
    border: 1px solid #fff;
  }

  tr:nth-child(odd) {
    background: #f6f6f8;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/teachplan/components/PlanList.vue